// extracted by mini-css-extract-plugin
export default {"candidates-details-container":"UpdateGuest_candidates-details-container__avzKx","override-input-field":"UpdateGuest_override-input-field__Fi8hg"};